/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum EventEntityKinds {
    Product = 110000,
    Customer = 120000,
    Employee = 140000,
    DocumentType = 150000,
    SystemSettings = 160000,
    ConfiguratorList = 170000,
    ConfiguratorListItem = 180000,
    ConfiguratorAttribute = 190000,
    ConfiguratorRule = 200000,
}
